(function () {
  if (window.__tvReels) { window.__tvReels.scan(); return; }

  var REDUCED = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var CAN_HOVER = !!(window.matchMedia && window.matchMedia('(hover: hover)').matches);
  var SAVE_DATA = !!(navigator.connection && navigator.connection.saveData);
  var SWIPE_MIN = 40;

  var instances = [];
  var openOverlays = {};
  var docHidden = false;

  function track(name, data) {
    try { document.dispatchEvent(new CustomEvent('trivelle:track', { detail: { name: name, data: data || {} } })); } catch (e) {}
  }
  function overlayUp() { for (var k in openOverlays) { if (openOverlays[k]) return true; } return false; }
  function up(el, sel) {
    while (el && el.nodeType === 1) { if (el.matches && el.matches(sel)) return el; el = el.parentNode; }
    return null;
  }
  function syncAll() { for (var i = 0; i < instances.length; i++) instances[i].sync(); }

  function claim(root) {
    var v = root.querySelectorAll('video[data-tv-lazy-video]');
    for (var i = 0; i < v.length; i++) v[i]._loaded = 1;
  }

  function build(root) {
    if (root._tvReels) return null;
    root._tvReels = 1;
    claim(root);

    var stage = root.querySelector('[data-tv-reels-stage]');
    var cards = [].slice.call(root.querySelectorAll('.reel'));
    var n = cards.length;
    if (!stage || !n) return null;

    var nav = root.querySelector('[data-tv-reels-nav]');
    var live = root.querySelector('[data-tv-reels-live]');
    var half = Math.floor(n / 2);
    var auto = root.getAttribute('data-tv-auto') !== 'false';
    var interval = parseInt(root.getAttribute('data-tv-interval'), 10);
    if (!interval || interval < 2000) interval = 5000;

    var idx = 0;
    var timer = null;
    var dots = [];
    var hovering = false, focused = false, inView = false, editorHold = false;
    var swipeGuard = 0, x0 = null, y0 = null;

    function btnOf(li) { return li.querySelector('.reel-card'); }
    function vidOf(li) { return li.querySelector('video'); }

    function showPosters() {
      if (root._tvPosters) return;
      root._tvPosters = 1;
      for (var i = 0; i < cards.length; i++) {
        var v = vidOf(cards[i]);
        if (!v) continue;
        var p = v.getAttribute('data-poster');
        if (!p) continue;
        v.poster = p;
        v.removeAttribute('data-poster');
      }
    }

    function attach(v) {
      if (!v || v._tvSrc) return;
      v._tvSrc = 1;
      var srcs = v.querySelectorAll('source[data-src]');
      for (var i = 0; i < srcs.length; i++) {
        srcs[i].src = srcs[i].getAttribute('data-src');
        srcs[i].removeAttribute('data-src');
      }
      try { v.preload = 'metadata'; v.load(); } catch (e) {}
    }
    function playCentre() {
      var v = vidOf(cards[idx]);
      if (!v) return;
      attach(v);
      try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {}
    }
    function quiet(keep) {
      for (var i = 0; i < n; i++) {
        if (i === keep) continue;
        var v = vidOf(cards[i]);
        if (!v) continue;
        try { v.pause(); } catch (e) {}
        try { if (v.currentTime) v.currentTime = 0; } catch (e) {}
      }
    }
    function prefetchNext() {
      if (SAVE_DATA || n < 2) return;
      attach(vidOf(cards[(idx + 1) % n]));
    }

    function mediaOn() { return !REDUCED && inView && !docHidden && !overlayUp(); }
    function timerOn() { return auto && n > 1 && !REDUCED && inView && !docHidden && !overlayUp() && !hovering && !focused && !editorHold; }

    function stop() { if (timer) { clearTimeout(timer); timer = null; } }
    function restart() {
      stop();
      if (!timerOn()) return;
      timer = setTimeout(function () { go(idx + 1, false); }, interval);
    }

    function render() {
      for (var i = 0; i < n; i++) {
        var d = i - idx;
        if (d > half) d -= n;
        else if (d < -half) d += n;
        if (d > 2) d = 3; else if (d < -2) d = -3;
        var li = cards[i];
        var centre = d === 0;
        if (li.getAttribute('data-pos') !== String(d)) li.setAttribute('data-pos', String(d));
        var b = btnOf(li);
        if (b) {
          b.tabIndex = centre ? 0 : -1;
          if (centre) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
        }
        var a = li.querySelector('.reel-meta a');
        if (a) a.tabIndex = centre ? 0 : -1;
      }
      for (var k = 0; k < dots.length; k++) {
        var on = k === idx;
        dots[k].classList.toggle('on', on);
        dots[k].tabIndex = on ? 0 : -1;
        dots[k].setAttribute('aria-current', on ? 'true' : 'false');
      }
    }

    function announce() {
      if (!live) return;
      var v = cards[idx].querySelector('.reel-views');
      live.textContent = 'Reel ' + (idx + 1) + ' of ' + n + (v ? ', ' + v.textContent : '');
    }

    function apply(user) {
      render();
      quiet(mediaOn() ? idx : -1);
      if (mediaOn()) { playCentre(); prefetchNext(); }
      if (user) announce();
      restart();
    }
    function go(i, user) {
      idx = ((i % n) + n) % n;
      apply(user);
    }
    function focusCentre() {
      var b = btnOf(cards[idx]);
      if (!b) return;
      try { b.focus({ preventScroll: true }); } catch (e) { try { b.focus(); } catch (e2) {} }
    }

    if (nav && n > 1) {
      nav.setAttribute('role', 'group');
      nav.setAttribute('aria-label', 'Choose a reel');
      for (var d0 = 0; d0 < n; d0++) {
        (function (i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'reel-dot';
          b.tabIndex = i === 0 ? 0 : -1;
          b.setAttribute('aria-label', 'Show reel ' + (i + 1) + ' of ' + n);
          b.addEventListener('click', function () { go(i, true); });
          nav.appendChild(b);
          dots.push(b);
        })(d0);
      }
    }

    stage.addEventListener('click', function (e) {
      if (swipeGuard) { swipeGuard = 0; e.preventDefault(); e.stopPropagation(); return; }
      var li = up(e.target, '.reel');
      if (!li) return;
      var i = cards.indexOf(li);
      if (i < 0) return;
      if (i === idx) {
        if (up(e.target, '.reel-card')) track('tv_reel_open', { index: i + 1, of: n });
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      go(i, true);
    }, true);

    if (CAN_HOVER) {
      root.addEventListener('mouseenter', function () { hovering = true; stop(); });
      root.addEventListener('mouseleave', function () { hovering = false; restart(); });
    }

    root.addEventListener('focusin', function (e) {
      var kb = true;
      try { kb = !!(e.target && e.target.matches && e.target.matches(':focus-visible')); } catch (err) { kb = true; }
      if (!kb) return;
      focused = true;
      stop();
    });
    root.addEventListener('focusout', function (e) {
      if (root.contains(e.relatedTarget)) return;
      focused = false;
      restart();
    });

    root.addEventListener('keydown', function (e) {
      if (e.altKey || e.ctrlKey || e.metaKey) return;
      if (overlayUp()) return;
      var j = -1;
      if (e.key === 'ArrowRight') j = idx + 1;
      else if (e.key === 'ArrowLeft') j = idx - 1;
      else if (e.key === 'Home') j = 0;
      else if (e.key === 'End') j = n - 1;
      else return;
      e.preventDefault();
      go(j, true);
      focusCentre();
    });

    stage.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      x0 = null; y0 = null;
      if (Math.abs(dx) <= SWIPE_MIN || Math.abs(dx) <= Math.abs(dy)) return;
      swipeGuard = 1;
      setTimeout(function () { swipeGuard = 0; }, 400);
      go(idx + (dx < 0 ? 1 : -1), true);
    }, { passive: true });

    stage.addEventListener('scroll', function () {
      if (stage.scrollLeft) stage.scrollLeft = 0;
      if (stage.scrollTop) stage.scrollTop = 0;
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var was = inView;
          inView = entries[i].isIntersecting;
          if (inView) showPosters();
          if (was !== inView) apply(false);
        }
      }, { rootMargin: '300px 0px' });
      io.observe(stage);
    } else {
      inView = true;
      showPosters();
    }

    var api = {
      sync: function () { apply(false); },
      hold: function (el) {
        var i = cards.indexOf(el);
        if (i < 0 && !root.contains(el)) return;
        editorHold = true;
        if (i >= 0) go(i, true); else stop();
      },
      release: function () { editorHold = false; restart(); }
    };
    apply(false);
    return api;
  }

  function scan() {
    var roots = document.querySelectorAll('[data-tv-reels]');
    for (var i = 0; i < roots.length; i++) {
      var api = build(roots[i]);
      if (api) instances.push(api);
    }
  }

  document.addEventListener('visibilitychange', function () {
    docHidden = !!document.hidden;
    syncAll();
  });
  document.addEventListener('trivelle:popup', function (e) {
    var d = (e && e.detail) || {};
    var src = d.source || 'overlay';
    if (d.open) openOverlays[src] = 1; else delete openOverlays[src];
    syncAll();
  });
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:block:select', function (e) {
    for (var i = 0; i < instances.length; i++) instances[i].hold(e.target);
  });
  document.addEventListener('shopify:block:deselect', function () {
    for (var i = 0; i < instances.length; i++) instances[i].release();
  });

  window.__tvReels = { scan: scan };
  scan();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
})();
